import { ArrowRight, LucideIcon } from "lucide-react";

interface IndustrialFeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  link: string;
  /** Mittlere Karte invertiert (Deep-Blue-Fläche) — wie im Mock. */
  inverted?: boolean;
  /** Klick-Handler für den CTA — ohne Handler war der "Link" nur Deko (TES-1072). */
  onLinkClick?: () => void;
  /** Test-Anker für den CTA-Button (E2E). */
  linkTestId?: string;
}

/**
 * Flache outline-variant-Feature-Karte (TES-967, D5) nach Stitch-Mock screen-12.
 * Eine Karte (mittig) ist Deep-Blue-invertiert als visueller Anker.
 */
export function IndustrialFeatureCard({
  icon: Icon,
  title,
  description,
  link,
  inverted = false,
  onLinkClick,
  linkTestId,
}: IndustrialFeatureCardProps) {
  if (inverted) {
    return (
      <div className="group relative flex min-h-[20rem] flex-col justify-between overflow-hidden rounded-lg border border-border bg-brand p-8 text-white shadow-xl sm:p-10">
        <div className="relative z-10">
          <div className="mb-8 flex h-14 w-14 items-center justify-center rounded-lg bg-secondary text-secondary-foreground">
            <Icon className="h-7 w-7" />
          </div>
          <h3 className="mb-4 font-display text-lg font-semibold text-secondary-fixed">{title}</h3>
          <p className="leading-relaxed text-white/75">{description}</p>
        </div>
        <button
          type="button"
          onClick={onLinkClick}
          data-testid={linkTestId}
          className="relative z-10 mt-6 flex items-center gap-2 text-[11px] font-bold uppercase tracking-wide text-secondary-fixed transition-transform group-hover:translate-x-2"
        >
          <span>{link}</span>
          <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>
    );
  }

  return (
    <div className="group flex min-h-[20rem] flex-col justify-between rounded-lg border border-border bg-card p-8 transition-colors duration-300 hover:border-secondary sm:p-10">
      <div>
        <div className="mb-8 flex h-14 w-14 items-center justify-center rounded-lg bg-brand-container text-brand-container-foreground">
          <Icon className="h-7 w-7" />
        </div>
        <h3 className="mb-4 font-display text-lg font-semibold text-primary">{title}</h3>
        <p className="leading-relaxed text-muted-foreground">{description}</p>
      </div>
      <button
        type="button"
        onClick={onLinkClick}
        data-testid={linkTestId}
        className="mt-6 flex items-center gap-2 text-[11px] font-bold uppercase tracking-wide text-primary transition-transform group-hover:translate-x-2"
      >
        <span>{link}</span>
        <ArrowRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
